module.exports = "/call-frontend/img/assistant_avatar.6899442d.png";